module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead10-4dc4b70b59abc3f13011ac1828b7a93c.jpg";